import React from 'react';
import './style.css';

export const ButtonLarge = ({
  text,
  buttonLargeClassName,
  style,
  onClick,
  disabled = false,
}) => {
  return (
    <button
      className={buttonLargeClassName}
      onClick={onClick}
      style={style}
      disabled={disabled}
    >
      {text}
    </button>
  );
};

export default ButtonLarge;